'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _common = require('./common/common');

var _common2 = _interopRequireDefault(_common);

var _containers = require('./containers/containers');

var _containers2 = _interopRequireDefault(_containers);

var _app = require('./app.component');

var _app2 = _interopRequireDefault(_app);

var _constants = require('./utils/constants');

var _constants2 = _interopRequireDefault(_constants);

require('normalize.css');

var _env = require('./utils/env');

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('app', [_angularUiRouter2.default, _common2.default.name, _containers2.default.name, "kendo.directives"]).config(function ($locationProvider) {
  'ngInject';
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode

  $locationProvider.html5Mode(true).hashPrefix('!');
}).run(function ($rootScope, $window, $state, $location, AuthService, AppContextService, EventsService) {
  'ngInject';

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    var defaultState = _env2.default.defaultState();
    var pageTitle = _env2.default.pageTitle();

    $window.document.title = pageTitle;

    if (toState.name != 'login') {
      if (!AuthService.isAuthorized()) {
        console.log("Access denied");
        $state.go('login');
        event.preventDefault();
      } else {
        if (!AppContextService.getAppContext()) {
          AppContextService.fetchAppContext(function (response) {
            var roles = response.data.roles;

            if (AppContextService.hasAccess(roles)) {

              AppContextService.setAppContext(response.data);
              EventsService.broadcast(_constants2.default.events.AUTHORIZATION_SUCCESS);

              if (AppContextService.hasReadAccess(roles)) {

                if (toState.name != defaultState) $state.go(defaultState);
              }
            } else {
              $state.go("login");
            }
          }, function () {
            $state.go("login");
          });
        } else {

          var roles = AppContextService.getAppContext().roles;

          if (AppContextService.hasReadAccess(roles)) {
            // Allow navigation to all admin states, only redirect analytics users to analytics
            if (toState.name.indexOf("analytics") == -1 && _env2.default.isAnalytics()) {
              event.preventDefault();
              $state.go(defaultState);
            }
          }
        }
      }
    }
  });

  if ($location.path() == "/") {
    var defaultState = _env2.default.defaultState();
    $state.go(defaultState);
  }
}).component('app', _app2.default);


/** WEBPACK FOOTER **
 ** ./client/app/app.js
 **/